import {
  API_ERROR_MESSAGE,
  INCORRECT_REGISTRATION_NUMBER,
  NO_RESULTS_FOUND,
} from '../../utils/Constants'
import { API_CALL_TYPE, getAPIUrl } from '../API'
import { ProductIds } from '../apiConstants'
import { makeApiCall } from '../APIService'

interface HandleXpertBusinessSearchCompanyProps {
  companyRegistrationNumber: string
  companyName: string
  purpose?: string
  companyVATNumber?: string
  companySoleProprietorId?: string
  searchParam: string
  setXpertBusinesses?: any
  setShowProgress: React.Dispatch<React.SetStateAction<boolean>>
  setIsError: (isError: boolean) => void
  setErrorMessage: (errorMessage: string) => void
  kimNumber?: string
}

export const handleXpertBusinessSearchCompany: (
  props: HandleXpertBusinessSearchCompanyProps,
) => void = (props: HandleXpertBusinessSearchCompanyProps): void => {
  const {
    companyRegistrationNumber,
    companyName,
    companyVATNumber,
    companySoleProprietorId,
    searchParam,
    purpose,
    setShowProgress,
    setIsError,
    setErrorMessage,
    setXpertBusinesses,
  } = props
  const API_URL: string = getAPIUrl() + '/BusinessEnquiry/search-company'
  const body: {
    registrationNumber?: string
    businessName?: string
    vatNumber?: string
    purpose?: string
    soleProprietorId?: string
  } = {
    registrationNumber: companyRegistrationNumber,
    businessName: companyName,
    vatNumber: companyVATNumber,
    purpose: purpose,
    soleProprietorId: companySoleProprietorId,
  }
  setShowProgress(true)
  setIsError(false)
  setErrorMessage('')
  makeApiCall(
    API_CALL_TYPE.POST_CALL,
    API_URL,
    (response: { statusCode: number; data: any[] }) => {
      if (!response.data.length) {
        let searchCriteria = ''

        if (companyName) searchCriteria += `Business Name: ${companyName} `
        if (companyRegistrationNumber)
          searchCriteria += `Registration Number: ${companyRegistrationNumber} `
        if (companySoleProprietorId)
          searchCriteria += `Sole Proprietor ID: ${companySoleProprietorId} `
        if (companyVATNumber)
          searchCriteria += `VAT Number: ${companyVATNumber} `

        alert(`No results found for: ${searchCriteria}`)

        setShowProgress(false)
      } else {
        setXpertBusinesses(response.data)
        setShowProgress(false)
      }
    },
    (error: { response: { data: { message: string } } }) => {
      console.log(error)
      setShowProgress(false)
      setIsError(true)
      setErrorMessage(API_ERROR_MESSAGE)
    },
    body,
    {
      Authorization: 'Bearer ' + sessionStorage.getItem('jwt'),
    },
    null,
    false,
  )
}

interface handleXpertBusinessLoadReportProps {
  setShowProgress: React.Dispatch<React.SetStateAction<boolean>>
  setIsError: (isError: boolean) => void
  setErrorMessage: (errorMessage: string) => void
  business: {
    enquiryId: string
    enquiryResultId: string
    registrationNo: string
  }
  productId: number
  reportTypeId: number
  reference: string
  setReportId: React.Dispatch<React.SetStateAction<number>>
  setShowDownloadReport: React.Dispatch<React.SetStateAction<boolean>>
  purpose?: string
  isFirstBoxChecked?: boolean
  isSecondBoxChecked?: boolean
  downloadReport: (reportId?: string) => void
}

export const handleXpertBusinessLoadReport = (
  props: handleXpertBusinessLoadReportProps,
): void => {
  const {
    setShowProgress,
    setIsError,
    setErrorMessage,
    business,
    reference,
    setReportId,
    setShowDownloadReport,
    reportTypeId,
    productId,
    purpose,
    isFirstBoxChecked,
    isSecondBoxChecked,
    downloadReport,
  } = props
  const API_URL: string = getAPIUrl() + '/BusinessEnquiry/load-report'
  const body = {
    enquiryId: business.enquiryId,
    enquiryResultId: business.enquiryResultId,
    registrationId: business.registrationNo,
    productId: productId,
    reference,
    reportType: reportTypeId,
    purpose: purpose || 'placeholder',
    individualConsent: isSecondBoxChecked,
    purposeConsent: isFirstBoxChecked,
  }
  setShowProgress(true)
  setIsError(false)
  setErrorMessage('')
  makeApiCall(
    API_CALL_TYPE.POST_CALL,
    API_URL,
    (response) => {
      if (response.statusCode !== 200) {
        setIsError(true)
        setErrorMessage(API_ERROR_MESSAGE)
      } else {
        setShowProgress(false)
        downloadReport(response.data.reportId)
        setReportId(response.data.reportId)
        setShowDownloadReport(true)
      }
    },
    (error) => {
      console.log(error)
      setShowProgress(false)
      setIsError(true)
      setErrorMessage(error?.response?.data?.message || API_ERROR_MESSAGE)
    },
    body,
    {
      Authorization: 'Bearer ' + sessionStorage.getItem('jwt'),
    },
    null,
    false,
  )
}

interface handleDownloadCipcReportProps {
  reportId: number
  setShowProgress: React.Dispatch<React.SetStateAction<boolean>>
  setIsError: (isError: boolean) => void
  setErrorMessage: (errorMessage: string) => void
  reportTypeId: number
}

export const downloadReport = (props: handleDownloadCipcReportProps): void => {
  const {
    reportId,
    setShowProgress,
    setIsError,
    setErrorMessage,
    reportTypeId,
  } = props
  const requestOptions: RequestInit = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + sessionStorage.getItem('jwt'),
    },
    body: JSON.stringify({
      reportId,
      reportType: reportTypeId,
    }),
  }
  setShowProgress(true)
  setIsError(false)
  setErrorMessage('')
  fetch(getAPIUrl() + '/BusinessEnquiry/download-report', requestOptions)
    .then((res: Response) => {
      return res.blob()
    })
    .then((blob: Blob) => {
      setShowProgress(false)
      const href = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = href
      link.setAttribute('download', 'businessreport.pdf')
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    })
    .catch((error: any) => {
      setIsError(true)
      setErrorMessage(API_ERROR_MESSAGE)
      setShowProgress(false)
      return Promise.reject({ Error: 'Something Went Wrong', error })
    })
}
